"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var title = _ref.title,
      closeOnEsc = _ref.closeOnEsc,
      closeOnBlur = _ref.closeOnBlur,
      showCloseButton = _ref.showCloseButton;
  return "<div class=\"reveal-modal\" aria-hidden=\"true\" role=\"dialog\" data-reveal data-options=\"close_on_esc:".concat(closeOnEsc, ";close_on_background_click:").concat(closeOnBlur, ";\">\n    <div class=\"modal-header\">\n        <h2 class=\"modal-title primary-color\" tabindex=\"0\">").concat(title, "</h2>\n        ").concat(showCloseButton ? "<a class=\"close-reveal-modal js-close\" role=\"button\" aria-label=\"".concat(window.html('close'), "\" tabindex=\"0\">&#215;</a>") : '', "\n    </div>\n\n    <div class=\"modal-container\"></div>\n</div>");
};

exports["default"] = _default;